<div class="block-sender">
  <ng-container *ngIf="loading">
    <div class="loading">
      <p-progressSpinner [style]="{width: '24px', height: '24px'}" styleClass="dark-spinner" strokeWidth="6"></p-progressSpinner>
    </div>
  </ng-container>
  <ng-container *ngIf="!loading">
    <p>
      {{'ui.block_sender.warning' | translate}}
      <a [href]="helpLink + '/digital-practice/en/'" class="block-info" target="_blank"><img [src]="'questionMarkIcon' | themeIconUrl: theme" height="20" class="help-icon" alt="" ></a>
    </p>
    <div class="btn-row">
      <button pButton [label]="'ui.block_sender.cancel' | translate" class="p-button-third p-button-sm" (click)="closeBlockSender()"></button>
      <button pButton [label]="'ui.block_sender.block_sender' | translate" class="pm-button-secondary p-button-sm" (click)="blockSender()"></button>
    </div>
  </ng-container>
</div>
